import { render, staticRenderFns } from "./multidamagePhotoclaimForm.pug?vue&type=template&id=83de118e&lang=pug&external"
import script from "./multidamagePhotoclaimForm.js?vue&type=script&lang=js&external"
export * from "./multidamagePhotoclaimForm.js?vue&type=script&lang=js&external"
import style0 from "./multidamagePhotoclaimForm.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83de118e')) {
      api.createRecord('83de118e', component.options)
    } else {
      api.reload('83de118e', component.options)
    }
    module.hot.accept("./multidamagePhotoclaimForm.pug?vue&type=template&id=83de118e&lang=pug&external", function () {
      api.rerender('83de118e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/multidamagePhotoclaimForm/index.vue"
export default component.exports